import React, { Component } from "react";
import { reaction } from "mobx";
import { observer, inject } from "mobx-react";
import {
  GridRow,
  GridColumn,
  Button,
  Toastr,
  Loader
} from "arv-reactcomponents";
import { CONTACT_US_V2 } from "npmlinks-constants";
import ContactUsSubjectInput from "../ContactUsSubjectInput";
import UserNameInput from "../UserNameInput";
import EmailInput from "../EmailInput";
import { getKeyFromDecodedToken, isAuthenticated } from "../../../../utils";

@inject("StaticPageStore", "LoginStore")
@observer
class ContactUsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      emailIsValid: false,
      name: "",
      nameIsValid: false,
      subject: "",
      subjectIsValid: false,
      message: "",
      loader: false,
      buttonDisabled: false
    };

    this.reactToLogIn = this.reactToLogIn.bind(this);
    this.handleUserNameInput = this.handleUserNameInput.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.handleSubjectInput = this.handleSubjectInput.bind(this);
    this.handleMessageInput = this.handleMessageInput.bind(this);
    this.onMessageSubmit = this.onMessageSubmit.bind(this);
    this.submitMessage = this.submitMessage.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this.reactToLogIn();
    const { email, name } = this.state;
    if (!email && !name && isAuthenticated()) {
      const userDetails = getKeyFromDecodedToken();
      if (
        userDetails.email_id &&
        userDetails.firstName
      ) {
        this.setState({
          email: userDetails.email_id,
          name: userDetails.firstName,
        });
      }
    }
  }

  reactToLogIn() {
    reaction(
      () => this.props.LoginStore.isUserLoggedIn,
      isUserLoggedIn => {
        if (isUserLoggedIn) {
          const userDetails = getKeyFromDecodedToken();
          if (
            userDetails.email_id &&
            userDetails.email_id.length > 0 &&
            userDetails.firstName &&
            userDetails.firstName.length > 0
          ) {
            this.setState({
              email: userDetails.email_id,
              name: userDetails.firstName,
            });
          }
        } else {
          this.setState({
            email: "",
            name: ""
          })
        }
      },
    );
  }

  handleUserNameInput(input) {
    this.setState({
      name: input.value,
      nameIsValid: input.isValid,
    });
  }

  handleEmailInput(input) {
    this.setState({
      email: input.value,
      emailIsValid: input.isValid,
    });
  }

  handleSubjectInput(input) {
    this.setState({
      subject: input.value,
      subjectIsValid: input.isValid,
    });
  }

  handleMessageInput(e) {
    this.setState({ message: e.target.value });
  }

  onMessageSubmit(e) {
    e.preventDefault();
    const { name, email, subject, message } = this.state;
    const contactUsMessage = {
      name,
      email,
      subject,
      message,
    };
    this.submitMessage(contactUsMessage);
  }

  submitMessage(messageObject) {
    this.setState({ loader: true, buttonDisabled: true });
    this.props.StaticPageStore.sendContactUsMessage(messageObject)
      .then(response => {
        this.setState({ loader: false, buttonDisabled: false });
        if (response.status) {
          Toastr.showToastr({
            className: "nwc-toastr-list-success nw-toastr",
            message: CONTACT_US_V2.successMessage,
            timeout: 3000,
          });
          this.resetForm();
        }
      })
      .catch(error => {
        this.setState({ loader: false, buttonDisabled: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: CONTACT_US_V2.errorMsg,
          timeout: 3000,
        });
      });
  }

  resetForm() {
    if (this.props.LoginStore.isUserLoggedIn) {
      this.setState({
        subject: "",
        subjectIsValid: false,
        message: "",
      });
    } else {
      this.setState({
        name: "",
        nameIsValid: false,
        email: "",
        emailIsValid: false,
        subject: "",
        subjectIsValid: false,
        message: "",
      });
    }
  }

  get isSubmitButtonEnable() {
    const { nameIsValid, emailIsValid, subjectIsValid, message } = this.state;
    return this.props.LoginStore.isUserLoggedIn
      ? subjectIsValid && message.length > 0
      : nameIsValid && emailIsValid && subjectIsValid && message.length > 0;
  }

  get isLoader() {
    return this.state.loader ? "" : "nwc-hide";
  }

  render() {
    const { name, email, subject, message, buttonDisabled } = this.state;
    const submitEnable = this.isSubmitButtonEnable;
    return (
      <form
        name="contactusForm"
        className="nw-contactusv2form nw-contactusv2-formcontainer"
        onSubmit={this.onMessageSubmit}
      >
        <GridRow>
          <GridColumn className="nwc-grid-col-sm nw-contactusv2form-container">
            <div className="nw-contactusv2form-label"> {CONTACT_US_V2.label1} </div>
            <UserNameInput.component
              className="nw-contactusv2form-input"
              id="contactusnamefield"
              name="contactusnamefield"
              placeholder=""
              text={name}
              validateUserNameInput={this.handleUserNameInput}
              required
            />
            <div className="nw-contactusv2form-label"> {CONTACT_US_V2.label2} </div>
            <EmailInput.component
              className="nw-contactusv2form-input"
              name="contactusemailfield"
              id="contactusemailfield"
              placeholder=""
              text={email}
              validateEmailInput={this.handleEmailInput}
              required
            />
            <div className="nw-contactusv2form-label"> {CONTACT_US_V2.label3} </div>
            <ContactUsSubjectInput.component
              className="nw-contactusv2form-input"
              name="contactussubjectfield"
              id="contactussubjectfield"
              placeholder=""
              text={subject}
              validateSubjectInput={this.handleSubjectInput}
              required
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm nw-contactusv2form-container">
            <div className="nw-contactusv2form-label"> {CONTACT_US_V2.label4} </div>
            <textarea
              className="nw-contactusv2form-textareainput"
              name="contactusmessagefield"
              id="contactusmessagefield"
              onChange={this.handleMessageInput}
              type="text"
              value={message}
              maxLength="500"
              required
            />
            <div className="nw-contactusv2form-buttonfield">
              <div className="nw-contactusv2form-submitbuttonwrap">
                <Button
                  className="nwc-btn-primary nwc-btn-sm nw-contactusv2form-submitbutton"
                  id="contactusform-submitbutton"
                  type="submit"
                  disabled={!submitEnable || buttonDisabled}
                >
                  {CONTACT_US_V2.label5}
                </Button>
                <Loader className={`nw-contactusv2form-loader ${this.isLoader}`} />
              </div>
            </div>
          </GridColumn>
        </GridRow>
      </form>
    );
  }
}

const getFinalComponent = component =>
  inject("StaticPageStore", "LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ContactUsForm.wrappedComponent,
  component: ContactUsForm,
};

export default ProjectComponent;
